import { Button } from "../button/button"
import { Action } from '../types'

type Props = {
    action: Action
    className?: string
    small?: boolean
    onClick?: () => void
}

export const ActionButton = (props: Props) => {
    const { action, className, onClick } = props

    return (
        <Button
            kind={action.kind || 'primary'}
            label={action.label}
            icon={action.icon}
            tooltip={action.tooltip}
            tooltipLines={action.tooltipLines}
            disabled={action.disabled}
            className={className}
            small={action.small}
            href={action.href}
            onClick={onClick || action.onClick}
        />
    )
}
